export default {
  // Units
  unit: '件',

  biz: '採用企業向け',
  agent: '人材紹介会社向け',
  logout: 'ログアウト',
  language: '言語',
  collapse: '折りたたむ',
  welcome: 'ようこそ',
  download: 'ダウンロード',
  delete: '削除',
  upload: 'アップロード',
  submit: '提出',
  cancel: 'キャンセル',
  close: '閉鎖',
  confirm: '確定',
  confirm1: '確認',
  ok: 'OK',
  yes: 'はい',
  edit: '編集',
  save: '保存',
  reset: 'リセット',
  search: '検索',
  view: '閲覧',
  detail: '詳細',
  success: '保存完了',
  failed: '保存に失敗しました',
  dataGetFailed: 'データの取得に失敗しました',
  loading: '読み込み中',
  uploading: 'アップロード中',
  downloading: 'ダウンロード中',
  downloadStarted: 'ダウンロード開始',
  downloadFailed: 'ダウンロード失敗',
  actions: '操作',
  downloadSuccess: 'ダウンロード完了',
  deleteSuccess: '削除完了',
  uploadSuccess: 'アップロード完了',
  uploadFailed: 'アップロードに失敗しました',
  chooseFile: 'ファイルを選択',
  chooseFileFromCompany: '企業の常用資料から必要なファイルを選択してください',
  addFile: 'ファイルを追加',
  manageFiles: '資料管理',
  emptyFileMessage: 'まだ追加されていません。企業の常用資料を先に管理してください',
  fileName: 'ファイル名',
  uploadTime: 'アップロード時間',
  fileSize: 'ファイルサイズ',
  prev: '前へ',
  next: '次へ',
  saveAndOut: '保存して終了',
  tableStats: '合計: #total# 件',
  fileFormatNotSupported: 'ファイル形式がサポートされていません。{0} 形式のファイルをアップロードしてください',
  fileSizeExceeded: '1つのファイルは {0} MBまでです',
  maxUploadCountExceeded: 'アップロードは最大 {0} ファイルまでです',
  confirmLeave: {
    title: 'このページから離れますか？',
    content: '変更内容はまだ保存されていません。本当に離れますか？',
  },
  confirmDeleteEmployee: {
    title: '候補者削除',
    content: '削除すると元に戻せません。候補者ID『{0}』を削除してよろしいですか？',
  },
  cannotDeleteEmployee: {
    title: '削除できません',
    content: '候補者ID「{0}」は進行中の選考が残っているため、進行中の選考を確認してください。',
    confirm: 'わかりました',
  },
  confirmDeleteFile: {
    title: 'ファイルを削除しますか？',
    content: '削除後は元に戻せません。ファイル『{0}』を削除してもよろしいですか？',
  },
  deleteConfirm: {
    title: '削除しますか？',
    taskContent: '削除後は元に戻せません。タスク『{name}-{number}』を削除してもよろしいですか？',
  },
  tokenExpired: 'ログインの有効期限が切れました。もう一度ログインしてください。',
  saveSuccess: '保存完了',
  addSuccess: '登録完了',
  addBtn: '登録',
  addFailed: '登録に失敗しました',
  saveFailed: '保存に失敗しました',
  pleaseLogin: 'ログイン後にご確認ください',
  logouting: 'ログアウト中',
  cancelSuccess: 'キャンセルに成功しました',
  confirmDelete: '削除の確認',
  operationFailed: '操作失敗',
  operationSuccess: '操作が成功しました',
  copySuccess: 'コピーしました',
  publishSuccess: '公開完了',
  publishFailed: '公開に失敗しました',
  mapDialog: {
    title: '地図で指定',
    searchPlaceholder: '住所検索',
    noAddressSelected: '住所未選択',
    confirmLocationTip: '位置を確認してください。正確な位置でないと求職者が迷う可能性があります',
    addressUpdated: '住所未選択',
    searchAddressFirst: '検索ボックスに住所を入力してください',
  },
  addressSelector: {
    provincePlaceholder: '都道府県',
    detailPlaceholder: '詳細住所（市区郡・町名・丁目・番地などを含む）',
    mapLocation: '地図で指定',
  },
  pleaseSelect: '選択してください',
  pleaseEnter: '入力してください',
  to: '〜',
  startDate: '開始',
  endDate: '終了',
  total: '合計',
  items: '件',
  fetchFailed: 'データの取得に失敗しました',
  loadFailed: '読み込みに失敗しました',
  requestTimeout: 'リクエストがタイムアウトしました。しばらくしてから再試行してください',
  networkError: 'ネットワークエラーが発生しました。ネットワーク接続を確認してください',
  deleteConfirmMessage: '削除後は元に戻せません。本当に削除しますか？',
  warning: '警告',
  deleteFailed: '削除に失敗しました',
  imgUpload: {
    view: '閲覧',
    download: 'ダウンロード',
    viewExample: '例を見る',
    downloadTemplate: 'テンプレートをダウンロード',
    fileFormatNotSupported: 'ファイル形式がサポートされていません。{formats} 形式のファイルをアップロードしてください',
    onlyImageAllowed: '画像ファイルのみアップロード可能です',
    fileTooLarge: 'ファイルサイズは {size} を超えることはできません',
    downloadSuccess: 'ダウンロード成功',
    loadFailed: '画像の読み込みに失敗しました',
  },
  no: 'いいえ',
  noData: 'データなし',
  currency: {
    jpy: '円',
  },
  units: {
    days: '日',
    hours: '時間',
    people: '人',
    years: '年',
    months: 'ヶ月',
    hoursPerMonth: '時間/月'
  },
  noAccessPermission: 'アクセス権限 なし',
  noAccessGoList: '一覧へ戻る なし',
  nextDay: '翌日',
  curDay: '当日',
  noSetting: '未設定',
  authChange: '権限が変更されました。再度ログインしてください。',
  searchNoData: '検索結果がありません',
  searchNoDataDetail: '検索条件を変更して再検索してください',
  noSystemAccess: '申し訳ございません。アクセス権限がありません。オーナー/管理者に連絡してください。',
  noCareerAccess: 'Career アクセス権限 なし',
  contactAdminToEnable: '管理者に権限の付与を依頼してください',
  enterTalentSystem: 'Talent システムに入る',
  add: '追加',
  emptyStates: {
    noConditions: {
      title: 'データなし',
    },
    noResults: {
      title: '検索結果はありません',
      description: '検索条件を変更して再検索してください'
    }
  },
  unopen: '未公開',
  parseSuccess: '解析完了',
  parseLoading: '解析中',
  parseFailed: '解析に失敗しました',
};
